<template>
  <div class="home">
    <myheader></myheader>
    <!-- <div class="content-contain"> -->
    <router-view></router-view>
    <!-- </div> -->
    <myfooter></myfooter>
  </div>
</template>

<script>
  // @ is an alias to /src
  import myfooter from './myfooter.vue';
  import myheader from './header.vue';
  export default {
    name: 'HomeView',
    components: {
      myheader,
      myfooter
    },
    data() {
      return {};
    },
    methods: {}
  };
</script>
<style lang="less" scoped>
  .home {
    min-width: 1200px;
    background: #f4f3f3;
  }
  .content-contain {
    width: 1100px;
    margin: 0 auto;
  }
</style>
